import { Controller } from "@hotwired/stimulus"

// Modal de verificación del teléfono del local (stores/_form). Vive FUERA del form
// principal del wizard porque los forms de verificar/reenviar no pueden anidarse.
// steps_controller lo abre con open({ url, phone }); el servidor reemplaza el frame
// store-phone-verification por turbo_stream (stores/_phone_verification). Cuando el frame
// llega verificado (data-phone-verified), emite store-phone-modal:verified y se cierra solo.
export default class extends Controller {
  static targets = ["idle", "offline"]

  async open({ url, phone }) {
    this.showTemplate(this.idleTarget)
    this.element.hidden = false

    try {
      const response = await fetch(url, {
        method: "POST",
        body: new URLSearchParams({ phone }),
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "text/vnd.turbo-stream.html"
        }
      })
      if (!(response.headers.get("content-type") || "").includes("turbo-stream")) throw new Error("not a stream")

      const html = await response.text()
      Turbo.renderStreamMessage(html)
      // Número ya verificado: el frame llega en estado verificado sin pasar por el form. El
      // marcador viaja dentro del <template> del stream (invisible para querySelector), y el
      // render es asíncrono, así que se lee del HTML: el atributo lo escribe nuestra parcial.
      const done = html.match(/data-phone-verified="([^"]*)"/)
      if (done) this.verified(done[1])
    } catch {
      this.showTemplate(this.offlineTarget)
    }
  }

  close() {
    clearTimeout(this.closeTimer)
    this.element.hidden = true
  }

  // Cerrar al tocar el fondo (no la card).
  backdrop(event) {
    if (event.target === this.element) this.close()
  }

  // turbo:submit-end burbujea desde los forms del frame; solo el de verificar cuenta.
  submitted(event) {
    if (event.detail.success && event.target.dataset.phoneVerify) this.verified(event.target.dataset.phone)
  }

  verified(phone) {
    this.dispatch("verified", { detail: { phone } })
    clearTimeout(this.closeTimer)
    this.closeTimer = setTimeout(() => this.close(), 1200) // deja ver el check
  }

  showTemplate(template) {
    this.element.querySelector("#store-phone-verification")?.replaceWith(template.content.cloneNode(true))
  }
}
